import * as d3 from 'd3'

export default {

  methods: {

    set_LocalValues(){

      this.safety = JSON.parse(JSON.stringify(this.DataItems))
      // this.cutoff = JSON.parse(JSON.stringify(this.Queries.SQL1[0].CUTOFF))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title   = json.title
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries

      // console.log(this.cutoff)
    },


  }
}